// Design Tokens (primitives)
export const colors = {
  light: {
    background: '#f1f5f9',
    surface: '#ffffff',
    surfaceAlt: '#f8fafc',
    text: '#0f172a',
    textDim: '#475569',
    primary: '#2563eb',
    primaryHover: '#1d4ed8',
    danger: '#dc2626',
    border: '#e2e8f0'
  },
  dark: {
    background: '#0f172a',
    surface: '#1e293b',
    surfaceAlt: '#334155',
    text: '#f1f5f9',
    textDim: '#94a3b8',
    primary: '#3b82f6',
    primaryHover: '#2563eb',
    danger: '#f87171',
    border: '#334155'
  }
};

export const spacing = [0,4,8,12,16,20,24,32];
export const radii = { sm: 2, md: 4, lg: 8, pill: 999 };
export const typography = {
  fontFamily: `system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif`,
  sizes: { xs: 12, sm: 14, md: 16, lg: 20, xl: 24 },
  lineHeights: { normal: 1.4, relaxed: 1.6 }
};
